import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { useState } from "react";

function SendDasModal({checked , id, hideResendMessageModal, handleSend}) {
    const [emailChecked, setEmailChecked] = useState(true);
	const [whatsappChecked, setWhatsAppChecked] = useState(true);


    const handleSubmit = () => {
        handleSend(id || checked, emailChecked, whatsappChecked)
    }

    return(
        <Dialog
				open
				onClose={hideResendMessageModal}
				aria-labelledby="resend-message-dialog-title"
				aria-describedby="resend-message-description"
			>
				<DialogTitle id="resend-message-title">
					Reenviar impostos - DAS?
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="resend-message-description">
						Para onde deseja reenviar o{id || checked.length === 1 ? "" : "s"}{" "}
						impost
						{id || checked.length === 1 ? "o" : "os"}?
					</DialogContentText>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start"
						}}
					>
						<div style={{ display: "flex", alignItems: "center" }}>
							<Checkbox
								checked={emailChecked}
								onChange={() => setEmailChecked(prevEmailChecked => !prevEmailChecked)}
								color="primary"
							/>
							<label>Enviar por E-mail</label>
						</div>

						<div style={{ display: "flex", alignItems: "center" }}>
							<Checkbox
								checked={whatsappChecked}
								onChange={() => setWhatsAppChecked(prevWhatsappChecked => !prevWhatsappChecked)}
								color="primary"
							/>
							<label>Enviar por WhatsApp</label>
						</div>
					</div>
				</DialogContent>
				<DialogActions style={{ padding: 20 }}>
					<Button onClick={() => handleSubmit()} color="primary">
						Enviar
					</Button>
					<Button onClick={hideResendMessageModal} color="secondary" autoFocus>
						Cancelar
					</Button>
				</DialogActions>
			</Dialog>
    )
}

export default SendDasModal